// @flow
import {containers} from "@swarm2/core"
import Icon from "material-ui/svg-icons/device/signal-wifi-off"
import * as React from "react"
import * as Util from "../common"

export default containers.nav.OfflineIcon(props => {
  if (props.isError) return <Util.Error inline error={props} />
  const {isConnected} = props
  return isConnected ? null : <Icon />
})



// WEBPACK FOOTER //
// ./src/nav/OfflineIcon.js